/**
 * Init Popup.
 * @param {HTMLElement} rootElement - The root element.
 * @return {void}
 *
 */
function initPopup( rootElement ) {
	const popups = rootElement.querySelectorAll( '.popup' );
	const popupLinks = rootElement.querySelectorAll( '.popup-link' );
	const popupCloseLinks = rootElement.querySelectorAll( '.popup-close' );
	const popupForms = rootElement.querySelectorAll( '.popup form' );

	if ( ! popups ) {
		return;
	}

	const openPopup = ( element ) => {
		// Get data attribute key.
		const selectedKey = element.dataset.key;

		popups.forEach( ( el ) => {
			const key = el.dataset.key;
			if ( key === selectedKey ) {
				el.setAttribute( 'aria-selected', 'true' );
				el.classList.add( 'active' );
			} else {
				el.setAttribute( 'aria-selected', 'false' );
				el.classList.remove( 'active' );
			}
		} );

		// Disable document scrolling
		document.documentElement.style.overflow = 'hidden';
	};

	const closePopup = ( element ) => {
		// Get data attribute key.
		element.setAttribute( 'aria-selected', 'false' );
		element.classList.remove( 'active' );

		// Enable document scrolling
		document.documentElement.style.overflow = '';
	};

	// Function to close all popups
	const closePopups = () => {
		popups.forEach( ( el ) => {
			closePopup( el );
		} );
	};

	const handleClick = () => {
		popupLinks.forEach( ( element ) => {
			element.addEventListener( 'click', function ( event ) {
				event.preventDefault();
				openPopup( element );
			} );
		} );

		// Close the popup when the "Close" button is clicked
		popupCloseLinks.forEach( ( element ) => {
			element.addEventListener( 'click', function ( event ) {
				event.preventDefault();
				closePopup( element?.closest( '.popup' ) );
			} );
		} );

		// Close the popup when clicking outside of it
		document.addEventListener( 'click', function ( event ) {
			if ( ! event.target.closest( '.popup-container' ) && ! event.target.closest( '.popup-link' ) ) {
				closePopups();
			}
		} );

		// Close the popup when pressing the "Esc" key
		document.addEventListener( 'keydown', function ( event ) {
			if ( event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27 ) {
				closePopups();
			}
		} );

		// Close the popup when the popup form submitted.
		popupForms.forEach( ( element ) => {
			element.addEventListener( 'submit', function () {
				closePopup( element?.closest( '.popup' ) );
			} );
		} );
	};

	handleClick();
}

window.initPopup = initPopup;
export default initPopup;
